module.exports = __webpack_public_path__ + "img/pjqr.af41c349.png";